<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Столовые</h2>
          <v-spacer></v-spacer>
          <v-text-field
          v-model="search"
          append-icon="search"
          label="Поиск"
          single-line
          hide-details
          clearable
          style="max-width: 400px"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          class="card-border"
          no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page="-1"
          :headers="headers"
          :items="cafes || []"
          :search="search"
          hide-default-footer dense
        >
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'cafes',
  data: () => ({
    cafes: null,
    search: null,
    headers: [
      { text: 'имя', value: 'title' },
      { text: 'код', value: 'cafeid' },
      { text: 'школы', value: 'schools' },
      { text: 'товаров', value: 'menucount' },
    ]
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    }
  },
  methods: {
    async fetch () {
      try {
        const { cafes } = await this.$store.dispatch('sioRequest', {
          topic: 'org-cafes'
        })
        this.cafes = cafes.filter(x => x.schools.length > 0 || x.locationid != null)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>
